import { render } from "./Market.vue?vue&type=template&id=60801007&scoped=true"
import script from "./Market.vue?vue&type=script&lang=js"
export * from "./Market.vue?vue&type=script&lang=js"

import "./Market.vue?vue&type=style&index=0&id=60801007&scoped=true&lang=css"

import exportComponent from "/Users/beerebeerey/github-classroom/MUICCS/cs340prj-beersilver/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60801007"]])

export default __exports__